<template>
  <div class="container-card">
    <div class="card-img">
      <img
        @click.stop="handleToCardDetail"
        :src="cardInfo.star_img_url"
        :onerror="defalutLogoUrl"
      />
    </div>

    <div class="card-title">{{ cardInfo.card_name || "知识点卡牌" }}</div>
    <van-rate
      v-if="cardInfo.card_type == 2"
      v-model="cardInfo.user_card_star"
      :size="20"
      disabled
      :count="cardInfo.max_star"
      :icon="iconUrl"
      :void-icon="voidIconUrl"
      void-color="rgba(0,0,0,0.15)"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      iconUrl: require("../../assets/images/aio/star.png"),
      voidIconUrl: require("../../assets/images/aio/void-star.png"),
      defalutLogoUrl:
        'this.src="' + require("../../assets/images/aio/occupied.png") + '"',
    };
  },
  props: {
    cardInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    key: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    handleToCardDetail() {
      this.$emit("handleToDetail", this.cardInfo, this.key);
    },
  },
};
</script>

<style lang="less" scoped>
.container-card {
  width: 2.77rem;
  // height: 5.4rem;
  color: #fff;
  font-size: 30px;
  display: flex;
  flex-direction: column;
  .card-img {
    width: 2.77rem;
    height: 3.95rem;
    background: url("../../assets/images/aio/occupied.png") no-repeat;
    background-size: 100% 100%;
    background-color: #fff;
  }
  img {
    width: 2.77rem;
    height: 3.95rem;
  }
  .card-title {
    font-size: 0.4rem;
    font-weight: 500;
    width: 2.77rem;
    text-align: left;
    color: #000000;
    margin: 0.15rem 0 0.12rem 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: 0.1rem;
  }
}
::v-deep .van-rate {
  padding-left: 0.1rem;
}
// ::v-deep .van-rate__icon--disabled {
//   color: rgba(0, 0, 0, 0.15);
// }
</style>
